// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { attachFile, downloadFile } from './fileThunk';

export interface fileState {}

const initialState: fileState = {};

const fileSlice = createSlice({
  name: 'file',
  initialState,
  reducers: {},
  extraReducers(builder) {
    // GET: Download File
    builder
      .addCase(downloadFile.pending, (_state) => {})
      .addCase(downloadFile.fulfilled, (_state) => {})
      .addCase(downloadFile.rejected, (_state) => {});

    // POST: Attach File
    builder
      .addCase(attachFile.pending, (_state) => {})
      .addCase(attachFile.fulfilled, (_state) => {})
      .addCase(attachFile.rejected, (_state) => {});
  },
});

// Action
export const fileActions = fileSlice.actions;

// Selectors

// Reducer
const fileReducer = fileSlice.reducer;
export default fileReducer;
